import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { CompanyProductUserMember } from 'src/app/models/company_product_user_member.model';
import { User } from 'src/app/models/user.model';
import { MatIcon } from '@angular/material/icon';
import { CompanyProductUserMemberRoleToColorPipe } from '../../../pipes/company-product-user-member-role-to-color.pipe';
import { CompanyProductUserMemberRoleToIconPipe } from '../../../pipes/company-product-user-member-role-to-icon.pipe';

@Component({
  selector: 'app-profile-pic-with-role',
  templateUrl: './profile-pic-with-role.component.html',
  styleUrls: ['./profile-pic-with-role.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, CompanyProductUserMemberRoleToColorPipe, CompanyProductUserMemberRoleToIconPipe],
})
export class ProfilePicWithRoleComponent implements OnInit, OnChanges {
  @Input() user: User | null;
  @Input() size: number = 50;
  @Input() can_remove: boolean = true;
  @Output() userClicked = new EventEmitter();
  @Input() company_product_user_member: CompanyProductUserMember | undefined = undefined;
  profile_pic: string = 'assets/img/default_profile_picture.png';

  constructor() {}

  ngOnInit(): void {
    this.updateUserData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user && !changes.user.firstChange) {
      this.updateUserData();
    }
  }

  updateUserData(): void {
    if (this.user != null && this.user.profile_picture_url != null) {
      this.profile_pic = this.user.profile_picture_url;
    } else {
      this.profile_pic = 'assets/img/default_profile_picture.png';
    }

    if (this.user != null) {
      if (this.company_product_user_member == null && (this.user as any).company_product_user_member != null) {
        this.company_product_user_member = (this.user as any).company_product_user_member;
      }
    }
  }

  onUserClick() {
    this.userClicked.emit(this.user?.id.toString());
  }
}
